import { Component, input, computed } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-calls-durations-tab',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    { provide: TabComponent, useExisting: CallsDurationsTabComponent },
  ],
  templateUrl: './calls-durations-tab.component.html',
  styleUrls: ['./calls-durations-tab.component.scss'],
  standalone: true,
})
export class CallsDurationsTabComponent extends TabComponent {
  override name = this.dictionaryService.get('CallsDurations');
  productId = input.required<string>();

  endpoint = computed(
    () => `/products/tables/version-durations/${this.productId()}`,
  );

  public async main(): Promise<void> {}
}
